import React from 'react';
import {List, Map} from 'immutable';
import pick from 'lodash/pick';
import connectToStores from 'alt-utils/lib/connectToStores';
import AdminTopicEditorPageActions from 'actions/admin/AdminTopicEditorPageActions';
import AdminFilterWordProfileStore from 'stores/admin/AdminFilterWordProfileStore';
import AuthStore from 'stores/AuthStore';
import TopicForm from 'components/admin/topics/TopicForm';
import Loading from 'components/pure/utils/Loading';
import AdminFilterWordProfileActions from 'actions/admin/AdminFilterWordProfileActions';
import AdminTopicEditorPageStore from 'stores/admin/AdminTopicEditorPageStore';

@connectToStores
export default class NewTopicFormContainer extends React.PureComponent {
  static getStores() {
    return [AdminFilterWordProfileStore, AuthStore];
  }

  static getPropsFromStores() {
    const fwState = AdminFilterWordProfileStore.getState();
    const loading = fwState.profilesInAccountLoading;
    const loadingError = fwState.profilesInAccountError;
    return {
      editable: AuthStore.getState().user.isAdmin(),
      loading,
      loadingError,
      ...pick(fwState, ['wordsToTopics']),
    };
  }

  static defaultProps = {
    // Existing topics get these from the server to render usage info in the sidebar, but,
    // obviously, a new topic has no usages.
    //
    // Putting these here like this so it's (hopefully) easy to find and change if needed.
    idToProfileMap: Map(),
    profileDepartmentAndTeamUsage: Map(),
    triggers: List(),
  };

  componentDidMount() {
    const {topic} = AdminTopicEditorPageStore.getState();
    if (!topic) {
      // Not set up yet -- user may have navigated manually. Set up now.
      AdminTopicEditorPageActions.setupTopicEditorForNewTopic();
    }
    // needed for topic word validation.
    AdminFilterWordProfileActions.fetchAccountProfiles();
  }

  render() {
    const {
      editable,
      idToProfileMap,
      loading,
      loadingError,
      profileDepartmentAndTeamUsage,
      triggers,
      wordsToTopics,
    } = this.props;
    if (loadingError) {
      return <p>There was an error loading the data.</p>;
    }
    if (loading) {
      return <Loading />;
    }
    return (
      <TopicForm
        editable={editable}
        idToProfileMap={idToProfileMap}
        profileDepartmentAndTeamUsage={profileDepartmentAndTeamUsage}
        triggers={triggers}
        wordsToTopics={wordsToTopics}
      />
    );
  }
}
